export const ENTRY_DATE_FIELD = 'entry_date';
export const DEDUCTION_DATE_FIELD = '_deduction_date';
